import { render, staticRenderFns } from "./JumpNode.vue?vue&type=template&id=08ba2d4c&scoped=true"
import script from "./JumpNode.vue?vue&type=script&lang=js"
export * from "./JumpNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba2d4c",
  null
  
)

export default component.exports